// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {
   filterCollection,
   getCollectionLength,
    sortCollection
} from '../../../../shared/services/collections';
import Accordion from '../../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import LaborRateChangeFilterOptions from '../../services/labor-rate-changes-filter-options';
import LaborRateChangesList from './labor-rate-changes-list';
import SearchFilters from '../../../../shared/state/search-filters';
import {buildNumber} from '../../../../shared/services/build-number';

function handleFilterByChange(filterBy) {

    this.actions.updateLaborRateChangesListFilterBy(filterBy);

}

function handleSortByChange(sortBy) {

    this.actions.updateLaborRateChangesListSortBy(sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateLaborRateChangesListSortDirection(sortDirection);

}

const LaborRateChangesAccordion = props => {

    let sortedCollection;

    sortedCollection = [...props.laborRateChanges];
    sortedCollection = sortCollection(props.laborRateChangesSearchFilters.sortBy, props.laborRateChangesSearchFilters.sortDirection, sortedCollection);
    sortedCollection = filterCollection(props.laborRateChangesSearchFilters.filterBy, LaborRateChangeFilterOptions, sortedCollection);
    const sortedCollectionLength = getCollectionLength(sortedCollection);

    const body = (
        <LaborRateChangesList
            laborRateChanges={sortedCollection}
            laborRateChangesSearchFilters={props.laborRateChangesSearchFilters}
            updateListFilterBy={props::handleFilterByChange}
            updateListSortBy={props::handleSortByChange}
            updateListSortDirection={props::handleSortDirectionChange}
        />
    );

    const title = (
        <FormattedMessage
            id='LABOR_RATE_CHANGES_WITH_COUNT'
            values={{
                count: buildNumber(sortedCollectionLength)
            }}
        />
    );

    return Object.keys(props.laborRateChanges).length > 0 &&
        <Accordion
            accordionId='labor-rate-changes-accordion'
            body={body}
            title={title}
        />;

};

LaborRateChangesAccordion.displayName = 'LaborRateChangesAccordion';
LaborRateChangesAccordion.propTypes = {
    laborRateChanges: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired,
    laborRateChangesSearchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    length: PropTypes.number.isRequired
};

export default LaborRateChangesAccordion;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/labor-rate-changes/labor-rate-accordion.js